import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getNotifications = (userId) => async (dispatch) => {
    dispatch({
        type: 'NOTIFICATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/notification/getbyuser/'+ userId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'NOTIFICATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'NOTIFICATION_NOT_LOADING'
        })
    }
}

export const removeNotification = (idNotification) => async (dispatch) => {
    try {
        const { status} = await Axios.put('/api/notification/setread/' + idNotification, {}, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'NOTIFICATION_EDIT_SUCCESS',
                payload: idNotification
            })
        }
    } catch (error) {
        dispatch({
            type: 'NOTIFICATION_ERROR'
        })
    }
}

export const removeNotifications = (idsNotifications) => async (dispatch) => {
    try {
        const { status} = await Axios.put('/api/notification/setsomeread', {idsNotifications}, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'NOTIFICATION_EDIT_SUCCESS',
                payload: idsNotifications
            })
        }
    } catch (error) {
        dispatch({
            type: 'NOTIFICATION_ERROR'
        })
    }
}